import { facadeApi } from 'api'
import { PaginationParams } from 'api/common/types'
import { Hub } from 'types/hubs/hubs'

export type Params = PaginationParams<{
  hubId: string
}>

export const fetchHubApi = ({ hubId }: Params) => facadeApi.get<Hub>(`/hubs/${hubId}`)
